import { axiosInstance } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/courses',
      method: 'GET',
      params: queryParams
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('courses', queryParams),
      method: 'GET',
      params: queryParams
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function startExam(ctx, data = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('courses', data) + '/start-exam',
      method: 'POST'
    })
    ctx.commit('test', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function saveProgress(ctx, data = {}) {
  try {
    const id = data.id
    delete data.id
    const response = await axiosInstance({
      url: `courses/${id}/save-progress`,
      method: 'POST',
      data
    })
    return response
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return '/' + state + '/' + params.id
  }
  return '/' + state
}
